import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { EditReportAccessInformationForm } from "app/component/report-access-information/EditReportAccessInformationForm";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { editReportVersionRoute, editReportVersionAccessInformationRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { ReportVersionStatus, useReportVersionAccessInformationQuery } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";

export const EditReportVersionAccessInformationScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(editReportVersionAccessInformationRoute);
    const [updated, setUpdated] = useState(false);
    const { data, loading, error } = useReportVersionAccessInformationQuery({
        variables: { versionId: reportVersionGraphId(versionId) },
    });
    const accessInformation = data?.reportVersion?.accessInformation;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!accessInformation) {
        return <ErrorScreen title="Error" message="Not found" />;
    }
    if (data?.reportVersion?.status !== ReportVersionStatus.Prerequisites) {
        return <ErrorScreen title="Error" message="This section may only be edited during the scoping status." />;
    }

    return updated ? (
        <Navigate to={editReportVersionRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionAccessInformationRoute} />
                <EditReportAccessInformationForm
                    accessInformationId={accessInformation._id}
                    onUpdate={() => setUpdated(true)}
                />
            </Container>
        </NavigationScreen>
    );
};
